import React from "react";
import { motion } from "framer-motion";
import { SITE } from "@/lib/site-config";
import { useSiteContent } from "@/lib/site-content";

const stats = [
  { value: "120+", label: "Coaching Kunden" },
  { value: "5+", label: "Jahre Erfahrung" },
  { value: "24h", label: "Antwortzeit" },
  { value: "100%", label: "Individuell" },
];

const AboutTobias = () => {
  const { images } = useSiteContent();
  return (
    <section id="about" className="relative py-20 md:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5 relative"
          >
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden border border-[rgba(255,255,255,0.14)]">
              <img
                src={images.about || SITE.images.about}
                alt="Tobias Nunner"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="font-display text-2xl font-black text-white tracking-tight">
                  Tobias Nunner
                </div>
                <div className="text-[11px] uppercase tracking-[0.22em] text-[#E9EAD8] mt-1">
                  Founder · Head Coach
                </div>
              </div>
            </div>
            {/* Decoration */}
            <div className="absolute -right-3 -bottom-3 hidden md:block">
              <div className="w-24 h-24 rounded-2xl border border-[#E8E5D0]/40 bg-[#E8E5D0]/[0.04]" />
            </div>
          </motion.div>

          {/* Text */}
          <div className="lg:col-span-7">
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#E8E5D0] mb-4">
                Über Tobias
              </div>
              <h2 className="font-display text-4xl sm:text-5xl font-black tracking-tighter leading-[0.95] text-balance">
                Echtes Coaching.
                <br />
                <span className="text-[#A8A58F]">Keine</span> One-Size-Fits-All.
              </h2>

              <div className="mt-8 space-y-5 text-[#C9C6B4] leading-relaxed">
                <p>
                  Tobi verbindet seit 5 Jahren Krafttraining und ganzheitliche
                  Gesundheit zu einem System, das im echten Alltag funktioniert.
                  Dabei geht es nicht um Studio-Mythen, Crash-Diäten oder leere
                  Versprechen, sondern um nachhaltige Ergebnisse, die sich
                  langfristig in dein Leben integrieren lassen.
                </p>
                <p>
                  Gemeinsam finden wir heraus, was dir wirklich Spaß macht.
                  Denn was dir liegt und Freude macht, kannst du langfristig
                  durchziehen. So wird Disziplin zur Selbstverständlichkeit –
                  strukturiert aus Krafttraining, Ernährung, Regeneration und
                  Mindset, individuell auf dein Leben zugeschnitten.
                </p>
              </div>

              <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
                {stats.map((s, i) => (
                  <motion.div
                    key={s.label}
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.08 }}
                    className="rounded-xl border border-[rgba(255,255,255,0.14)] bg-black/[0.02] p-4"
                  >
                    <div className="font-display text-3xl font-black lime-gradient-text">
                      {s.value}
                    </div>
                    <div className="text-[11px] uppercase tracking-[0.18em] text-[#A8A58F] mt-1">
                      {s.label}
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTobias;
